<template lang="pug">
#bloco-tabela-territorio-nao-enviado
    h1 Listagem de planilhas enviadas
    el-table(
        :data='data.itens',
        stripe,
        style='width: 100%',
        v-loading='carregandoTabela'
    )
        el-table-column(prop='planilha', label='Arquivo', width="400")
        el-table-column(prop='dataCadastro', label='Data de cadastro')
        el-table-column(prop='dataAtualizacao', label='Data de atualização')
        el-table-column(prop='status', label='Status')
            template(slot-scope='scope')
                el-tooltip(
                    effect='dark',
                    :content='scope.row.status.descricao',
                    placement='top'
                )
                    el-icon.el-icon-loading.lote-em-processamento(v-if="scope.row.status.codigo === 'EM_PROCESSAMENTO' || scope.row.status.codigo === 'ENVIADO'")
                    el-icon.el-icon-success.lote-concluido(v-if="scope.row.status.codigo === 'CONCLUIDO'")
                    el-icon.el-icon-warning.lote-concluido-com-erro(v-if="scope.row.status.codigo === 'CONCLUIDO_COM_ERROS'")
                    el-icon.el-icon-error.lote-com-erro(v-if="scope.row.status.codigo === 'ERRO_PROCESSAR'")
        el-table-column(label='Ações', align='center', width="100")
            .template.d-flex.justify-content-center.tabela-gestao-icone(
                slot-scope='scope'
            )
                el-dropdown.action-button(trigger='click', v-if="scope.row.status.codigo === 'CONCLUIDO_COM_ERROS'")
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='fazerDownload(scope.row.id)'
                        )
                            | Download da planilha com erros
    .tabela-gestao-contrato-originacao__paginacao
        span.pagina
            | {{ data.paginacao?.total }} {{ data.paginacao?.total <= 1 ? ' planilha' : ' planilhas' }}

        el-pagination(
            background,
            :page-size='pageCount',
            :pager-count='pageCount',
            :current-page.sync='paginaAtual',
            layout='prev, pager, next',
            :total='data.paginacao?.total',
            @current-change='buscarDadosLotes'
        )
</template>

<script>
import formatters from '@/utils/formatters';
import CertificacaoService from '@/services/CertificacaoService';

export default {
    name: 'BlocoTabelaNaoEnviadasCertificacao',
    props: {
        atualizar: {
            type: Object,
            required: true
        }
    },
    watch: {
        atualizar: function () {
            this.buscarDadosLotes();
        }
    },
    data() {
        return {
            territoriosSelecionados: [],
            carregandoTabela: false,
            paginaAtual: 0,
            pageCount: 5,
            data: {
                paginacao: {}
            }
        };
    },

    mounted() {
        this.buscarDadosLotes();
    },
    methods: {
        async handleSelectionChange(territorios) {
            this.territoriosSelecionados = territorios;

            var idsTerritorios = this.territoriosSelecionados.map(
                territorio => territorio.id
            );
            this.emiteRemoverTerritorioLote(idsTerritorios);
        },

        emiteRemoverTerritorioLote(idsTerritorios) {
            this.$emit('RemoverTerritorioLote', idsTerritorios);
        },

        formatarCar(car) {
            return formatters.reduzirCar(car);
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        removerTerritorio(territorios) {
            this.carregandoTabela = true;
            territorios.forEach(id => {
                let indice = this.data.findIndex(
                    obj => obj.id === id
                );
                if (indice !== -1) {
                    this.data.splice(indice, 1);
                }
            });
            this.paginaAtual = 1;
            setTimeout(() => {
                this.carregandoTabela = false;
            }, 500);
        },

        carregarTabela(valor) {
            this.carregandoTabela = valor;
        },

        async buscarDadosLotes() {
            this.carregandoTabela = true;
            try {
                const { data } = await CertificacaoService.buscarDadosLotes({page: this.paginaAtual - 1, size: this.pageCount});
                if (data) {
                    this.data = data;
                }
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao buscar dados de processamento.'
                });
            }
            this.carregandoTabela = false;
        },

        fazerDownload(id) {
            CertificacaoService.downloadPlanilhaComErro(id)
                .then(() => {
                    this.$notify.success({
                        message: 'Download realizado com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar download!'
                    });
                });
        }
    }
};
</script>

<style lang="scss">
#bloco-tabela-territorio-nao-enviado {
    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
        .el-table .cell .el-checkbox__inner {
            padding: 0px;
        }
    }
    
    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .el-checkbox__inner {
        margin-left: -10px;
    }

    i.lote-em-processamento {
        font-size: 16px;
        margin-left: 14px;
        color: silver;
    }
    i.lote-concluido {
        font-size: 16px;
        margin-left: 14px;
        color: var(--success);
    }
    i.lote-concluido-com-erro {
        font-size: 16px;
        margin-left: 14px;
        color: var(--warning);
    }
    i.lote-com-erro {
        font-size: 16px;
        margin-left: 14px;
        color: var(--color-alert);
    }
}
</style>
